/**
 * 移动端底部导航组件
 * 小红书风格设计
 */

import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../../stores/authStore'
import { getUnreadCount } from '../../services/notificationService'
import { ExploreIcon, DashboardIcon, NotifyIcon, UserIcon } from '../common/Icons'

interface MobileNavItem {
  path: string
  label: string
  icon: React.ReactNode
  showBadge?: boolean
}

// 需要隐藏底部导航的页面路径（包括精确匹配和前缀匹配）
const HIDDEN_NAV_PATHS_EXACT = ['/lab', '/publish', '/settings']
const HIDDEN_NAV_PATHS_PREFIX = ['/dashboard/agent'] // Dashboard 子页面

const mobileNavItems: MobileNavItem[] = [
  { path: '/', label: 'Explore', icon: <ExploreIcon className="mobile-nav-icon" /> },
  { path: '/dashboard', label: 'Dashboard', icon: <DashboardIcon className="mobile-nav-icon" /> },
  { path: '/publish', label: '', icon: null }, // 发布按钮特殊处理
  { path: '/notifications', label: 'Notifications', icon: <NotifyIcon className="mobile-nav-icon" />, showBadge: true },
  { path: '/profile', label: 'Profile', icon: <UserIcon className="mobile-nav-icon" /> },
]

const MobileNav: React.FC = () => {
  const location = useLocation()
  const { user, isLoggedIn } = useAuthStore()

  // 获取未读通知数量
  const { data: unreadCount = 0 } = useQuery({
    queryKey: ['unreadCount'],
    queryFn: async () => {
      if (!user) return 0
      return getUnreadCount(user.id)
    },
    enabled: !!user && isLoggedIn,
    refetchInterval: 60000, // 每分钟刷新
  })

  // 在特定页面隐藏底部导航
  const shouldHide = HIDDEN_NAV_PATHS_EXACT.includes(location.pathname) ||
    HIDDEN_NAV_PATHS_PREFIX.some(prefix => location.pathname.startsWith(prefix))

  if (shouldHide) {
    return null
  }

  return (
    <div className="mobile-bottom-nav">
      {mobileNavItems.map((item) => {
        // 发布按钮特殊处理
        if (item.path === '/publish') {
          return (
            <Link key={item.path} to={item.path} className="mobile-nav-item">
              <div className="mobile-nav-publish">+</div>
            </Link>
          )
        }

        return (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <div className="mobile-nav-icon-wrapper">
              {item.icon}
              {/* 通知未读数徽章 */}
              {item.showBadge && unreadCount > 0 && (
                <span className="mobile-nav-badge">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </div>
            <span>{item.label}</span>
          </Link>
        )
      })}
    </div>
  )
}

export default MobileNav